<template>
  <div class="onetest" v-if="oneItem">
    <h2>{{oneItem.name }}</h2>
    <div v-for="(obj,index) in oneItem.list" :key="index" class="topicBox">
      <div class="topicBox_1">
        <div :class="{fontSizeWe:obj.lastVoice}">{{obj.name}}</div>
        <!-- <div>
            <button class="butt" @click="bofang1">确认</button>
            <audio ref="audioS" class="aud" src="../../assets/mp3/one.mp3"></audio>
        </div>-->
      </div>
      <div class="checkboxS">
        <div class="checkboxS_box">
          <div v-if="obj.question" style="text-align: center">声 音</div>
          <el-radio-group v-model="obj.voice">
            <el-radio :label="1">正常</el-radio>
            <el-radio :label="2">异常</el-radio>
          </el-radio-group>
        </div>
        <div class="checkboxS_box">
          <div v-if="obj.question" style="text-align: center">语 畅</div>
          <el-radio-group v-model="obj.language">
            <el-radio :label="1">流畅</el-radio>
            <el-radio :label="2">不流畅</el-radio>
          </el-radio-group>
        </div>
        <div class="checkboxS_box">
          <div v-if="obj.question" style="text-align: center">语 调</div>
          <el-radio-group v-model="obj.intonation">
            <el-radio :label="1">正常</el-radio>
            <el-radio :label="2">异常</el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>
    <!-- <div class="resultAll">
      <div>{{oneItem.nameAll}}</div>
      <div class="checkboxS">
        <div class="checkboxS_box">
          <div style="text-align: center">声 音</div>
          <el-radio-group v-model="oneItem.voiceAll">
            <el-radio :label="1">正常</el-radio>
            <el-radio :label="2">异常</el-radio>
          </el-radio-group>
        </div>
        <div class="checkboxS_box">
          <div style="text-align: center">语 畅</div>
          <el-radio-group v-model="oneItem.languageALL">
            <el-radio :label="1">流畅</el-radio>
            <el-radio :label="2">不流畅</el-radio>
          </el-radio-group>
        </div>
        <div class="checkboxS_box">
          <div style="text-align: center">语 调</div>
          <el-radio-group v-model="oneItem.intonationAll">
            <el-radio :label="1">正常</el-radio>
            <el-radio :label="2">异常</el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
export default {
  name: "onetest",
  components: {},
  props: {
    oneItem: {}
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.topicBox {
  font-size: 20px;
  margin: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .topicBox_1 {
    display: flex;
  }
}
.audioMp3 {
  margin-left: 30px;
}
.checkboxS {
  display: flex;
  margin-left: 200px;
  .checkboxS_box {
    margin-left: 50px;
    .checkboxS_box_1 {
      display: flex;
      justify-content: center;
      .checkboxS_box_1_2 {
        margin-left: 20px;
      }
    }
  }
}
.fontSizeWe {
  font-weight: 800;
}
.resultAll {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 800;
  font-size: 20px;
}
</style>